<template>
  <div>
    <Manage />
  </div>
</template>

<script>
// 获取接口地址
import Manage from '../components/manage/manage.vue'

export default {
  name: 'Sjcz',
  components: {
    // sideMenu,
    // Header,
    Manage
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
